import { useMemo } from 'react';
import { useTranslations } from 'use-intl';

import { isSubscriptionStarted } from '@blockpulse3/data/shared';
import {
  FundraisingInvestStatus,
  FundraisingStatus,
  GetSubscriptionInfosFragment,
} from '@blockpulse3/graphql/hooks';

import { IBadge } from './useBadge';

export function useSubscriptionBadge(subscription: GetSubscriptionInfosFragment | null): IBadge {
  const i18nSubscriptionBadge = useTranslations('Subscription.Badge');

  const investStatus = subscription?.investStatus;

  return useMemo(() => {
    if (investStatus === FundraisingInvestStatus.REFUSED) {
      return { color: 'red', label: i18nSubscriptionBadge('Refused') };
    }
    if (subscription?.fundraising?.status === FundraisingStatus.FINALIZED) {
      return { color: 'green', label: i18nSubscriptionBadge('Finalized') };
    }
    if (investStatus === FundraisingInvestStatus.COMPLETED) {
      return { color: 'blue', label: i18nSubscriptionBadge('Completed') };
    }
    if (investStatus === FundraisingInvestStatus.APPROVED) {
      return { color: 'green', label: i18nSubscriptionBadge('Approved') };
    }
    if (investStatus === FundraisingInvestStatus.FINALIZED) {
      return { color: 'green', label: i18nSubscriptionBadge('Finalized') };
    }
    if (isSubscriptionStarted(subscription)) {
      return { color: 'yellow', label: i18nSubscriptionBadge('InProgress') };
    }
    return { color: 'gray', label: i18nSubscriptionBadge('Pending') };
  }, [investStatus, i18nSubscriptionBadge, subscription]);
}
